import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  { q: "How long does delivery take?", a: "Orders are dispatched next business day from our UK/EU warehouse and arrive within 1-2 business days across UK and EU with full tracking." },
  { q: "How are the compounds packaged?", a: "Each compound is synthesised and sealed under a nitrogen atmosphere by Trenta Medical, then shipped cold-chain (2–8°C) in protective, tamper-evident packaging." },
  { q: "How should I store them after delivery?", a: "Store sealed vials refrigerated at 2–8°C and away from light. Reconstituted material should be kept refrigerated and used within the stability window noted on the COA." },
  { q: "Do orders include a certificate of analysis?", a: "Yes. Every lot is tested by Janoshik Analytical, HPLC purity plus a separate pH test. Both PDFs are published on the product page before purchase and included in the box." },
  { q: "What if my package arrives damaged?", a: "We offer same-day replacement on damaged or lost shipments, or a full refund on request, no questions asked." },
  { q: "How do payments work?", a: "Checkout supports crypto and pay-by-bank (rolling out soon). Place your order and our team confirms payment details before dispatch." },
];

export default function Faq() {
  return (
    <section id="faq" className="border-b border-line bg-white" data-testid="faq">
      <div className="container-pd py-16 lg:py-24">
        <p className="label-mono text-brandblue">§ Common questions</p>
        <h2 className="mt-4 font-heading text-3xl font-extrabold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Before you order.
        </h2>
        <Accordion type="single" collapsible className="mt-10 max-w-3xl">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-line" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-heading text-base font-bold text-ink hover:text-brandblue">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-subtle">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
